
import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import DateRange from '@/components/DateRange.vue';
import api from '@/api';
import Util from '@/utils/util';

const { invitationCode } = api;

@Component({
  components: { DateRange },
})
export default class InvitationCodeList extends Vue {
  private data = { data: [], totalCount: 0, pageSize: 20, pageNo: 0 };

  private loading = false;

  private panel = 0;

  private headers = [
    { text: '推薦碼', value: 'invitationCode' },
    { text: '贈點明細', value: 'name' },
    { text: '贈送時機點', value: 'authStatus' },
    { text: '生效日期', value: 'startOn' },
    { text: '失效日期', value: 'endOn' },
    { text: '狀態', value: 'isEnabled' },
    { text: '動作', value: 'actions' },
  ];

  private authStatuses = ['一般會員', '基本認證', '實名認證'];

  private get totalCount() {
    return this.data.totalCount;
  }

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private get collection() {
    return [...(this.data.data || [])];
  }

  private filter = {
    invitationCode: this.$route.query.invitationCode || undefined,
    name: this.$route.query.name || undefined,
    startStartOn: this.$route.query.startStartOn || undefined,
    endStartOn: this.$route.query.endStartOn || undefined,
    startEndOn: this.$route.query.startEndOn || undefined,
    endEndOn: this.$route.query.endEndOn || undefined,
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private async updatePage(page: number) {
    this.filter.pageNo = page;
    await this.query();
  }

  private async search() {
    this.filter.pageNo = 1;
    await this.query();
  }

  private async query() {
    const query = {
      ...this.filter,
      pageSize: `${this.filter.pageSize}`,
      pageNo: `${this.filter.pageNo}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private async reset() {
    this.filter = {
      invitationCode: undefined,
      name: undefined,
      startStartOn: undefined,
      endStartOn: undefined,
      startEndOn: undefined,
      endEndOn: undefined,
      pageSize: 20,
      pageNo: 1,
    };
    await this.query();
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async requestData() {
    this.loading = true;
    const { data } = await invitationCode.list(this.filter);
    this.data = data;
    this.loading = false;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: InvitationCodeList) => void) | boolean) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
    });
  }
}
